import styles from "./AddAppointmentNavbar.module.css";

const items = [
  {
    label: "Appointment",
    type: "appointment",
  },
  {
    label: "Recurring Time Off",
    type: "recurring-exception",
  },
  {
    label: "Standard Time Off",
    type: "standard-exception",
  },
];

export const AddAppointmentNavbar = ({
  setAppointmentType,
  appointmentType,
}) => {
  return (
    <div className={styles.navbar}>
      <div className={styles.navLinks}>
        {items.map((item, index) => (
          <button
            key={index}
            onClick={() => {
              setAppointmentType(item.type);
            }}
            className={
              appointmentType === item.type
                ? styles.navLinkChecked
                : styles.navLink
            }
          >
            <span>{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
